import { render, staticRenderFns } from "./ColorSwatch.vue?vue&type=template&id=73d1e2ab&scoped=true&lang=pug&"
import script from "./ColorSwatch.vue?vue&type=script&lang=js&"
export * from "./ColorSwatch.vue?vue&type=script&lang=js&"
import style0 from "./ColorSwatch.vue?vue&type=style&index=0&id=73d1e2ab&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d1e2ab",
  null
  
)

export default component.exports